import React from 'react';
import moment from 'moment';
import { TimePicker } from '@progress/kendo-react-dateinputs';
import styled from 'styled-components';

import ErrorLabel from '../ErrorLabel';
import { transformLabels } from '../../../../utils/misc';
import { Colors } from '../../../../scss/common/style';

interface Props {
  id?: string;
  name?: string;
  defaultValue?: string | Date;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  cols?: number;
  label?: string;
  disabled?: boolean;
  value?: string | Date;
  height?: string | number;
  width?: string | number;
  placeholder?: string;
  min?: Date;
  max?: Date;
  touched?: any;
  errors?: any;
}

export default function TimePickerInputComponent({
  id = '',
  name = '',
  defaultValue = '',
  onBlur,
  onChange,
  cols,
  label,
  disabled = false,
  value = '',
  touched,
  errors,
  height,
  width,
  min,
  max,
  placeholder = 'hh:mm',
}: Props): JSX.Element {
  const toLocalDate = (val: string | Date | null | undefined): Date | null => {
    if (!val) return null;

    const date = moment.utc(val);
    return new Date(
      1970,
      0,
      1,
      date.hours(),
      date.minutes(),
      0,
      0
    );
  };

  const handleChange = (e: any) => {
    const localDate = e.value as Date;
    if (localDate instanceof Date && !isNaN(localDate.getTime())) {
      const utcDate = new Date(Date.UTC(1970, 0, 1, localDate.getHours(), localDate.getMinutes()));
      e.value = utcDate;
      onChange(e);
    } else {
      onChange(e);
    }
  };

  return (
    <div className={`form-group col-sm-${cols}`}>
      {label && (
        <LabelStyle className="ak-form-labels" {...(id ? { htmlFor: id } : {})}>
          {label || transformLabels(label)}
        </LabelStyle>
      )}
      <TimepickerWrapper>
        <TimePickerStyle
          style={{ borderRadius: '20px' }}
          id={id || undefined}
          height={height}
          width={width}
          name={name}
          placeholder={placeholder}
          onBlur={onBlur}
          onChange={handleChange}
          defaultValue={toLocalDate(defaultValue)}
          disabled={disabled}
          format="HH:mm"
          value={toLocalDate(value)}
          min={min}
          max={max}
        />
      </TimepickerWrapper>
      {touched && touched[name] && errors[name] && <ErrorLabel error={errors[name]} />}
    </div>
  );
}

const TimePickerStyle = styled(TimePicker) <{ height?: string | number; width?: string | number }>`
  border-radius: 20px;
  padding-bottom: 0;
  padding-left: 5px;
  height: ${(props) => (props.height ? props.height : 33)}px;
  width: ${(props) => (props.width ? props.width : '100%')};
  border: 1px solid #eeeeee !important;
  a {
    background-color: #fff !important;
    border-left: 1px solid #eeeeee !important;
    span {
      color: ${Colors.newOrage};
      background: #fff;
    }
  }
  input {
    padding-bottom: 3px;
    padding-left: 5px;
  }
`;

const TimepickerWrapper = styled.div`
  border-radius: 20px;
  position: relative;
  input {
    padding: 0 !important;
    height: 100%;
    &::placeholder {
      color: #b4b4b4 !important;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
      padding-left: 7px;
    }
  }
`;

const LabelStyle = styled.label`
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  color: ${Colors.darkBrown};
  text-align: left;
  width: 100%;
  margin-left: 10px;
  margin-bottom: 11px;
`;
